<div class="star-rating">
  @for (star of [].constructor(params.value); track star; let i = $index) {
    <span class="star" [class.filled]="i < params.value">*</span>
  }
</div>
